// REACT
import React, { Component } from "react";

// COOKIES
import cookie from "react-cookies";

// TRANSLATE
import { translate } from "react-i18next";

// COMPONENTS
import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.component";
import Cookies from "./components/cookies/cookies.component";

import axios from "axios";

// ROUTING
import Routing from "./routing";

class App extends Component {
  constructor() {
    super();
    this.state = {
      approved: cookie.load("approved"),
      location: null,
    };
  }

  componentWillMount() {
    localStorage.setItem("selectedCategory", 0);
    localStorage.setItem("selectedMember", JSON.stringify([true]));
    localStorage.setItem("selectedCountry", JSON.stringify([true]));
    localStorage.setItem("selectedQualification", JSON.stringify([true]));
    localStorage.setItem("selectedArea", JSON.stringify([true]));
    localStorage.setItem("page", 1);
    localStorage.setItem("order", 0);
    localStorage.setItem("neworder", 3);
    localStorage.setItem("isFilter", false);
    localStorage.setItem("countryValueDrop", JSON.stringify([]));
    localStorage.setItem("mapData", JSON.stringify([]));
  }

  componentDidMount() {
    this.initializeLanguageAndLocation();
  }
  
  initializeLanguageAndLocation = async () => {
    const requestLang = window.location.pathname.split("/");
    if (requestLang && requestLang[1]) {
      let lang = requestLang[1].toLowerCase();
      if (lang === 'pt' || lang === 'en') {
        this.props.i18n.changeLanguage(lang);
        this.setState({ location: lang });
        return;
      }
    }
  
    try {
      const res = await axios.get("https://ipwhois.app/json/");
      const location = res.data.country_code.toLowerCase();
      this.handleLocation(location);
    } catch (error) {
      console.error("ipwhois.io service failed, switching to ipapi.co: ", error);
      try {
        const res = await axios.get("https://ipapi.co/json/");
        const location = res.data.country_code.toLowerCase();
        this.handleLocation(location);
      } catch (error) {
        console.error("ipapi.co service also failed: ", error);
      }
    }
  
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
  
  handleLocation = (location) => {
    if (!location) return;
    const currentPath = window.location.pathname;
    if (location === 'pt' || location === 'en') {
      this.props.i18n.changeLanguage(location);
      if (!currentPath.startsWith(`/${location}`)) {
        window.location.replace(`/${location}`);
      }
    }
  };

  showPosition = (position) => {
    localStorage.setItem("latitude", position.coords.latitude);
    localStorage.setItem("longitude", position.coords.longitude);
  };

  setApproved = () => {
    this.setState({
      approved: true,
    });
  };

  render() {
    const { t, i18n } = this.props;
    const { approved } = this.state;

    return (
      <React.Fragment>
        {!approved && (
          <Cookies t={t} i18n={i18n} setApproved={this.setApproved} />
        )}
        <Header t={t} i18n={i18n} />
        <Routing />
        <Footer t={t} i18n={i18n} />
      </React.Fragment>
    );
  }
}

export default translate("translations")(App);



// WEBPACK FOOTER //
// ./src/App.js